import React, {useEffect, useState} from 'react'
import styles from './styles.module.scss'
import {connect} from 'react-redux'
import {
    chapterList,
    grantAdjunctNames,
    grantAdjunctNamesActive,
    grantAdjunctNamesActiveNoMo,
    grantAdjunctNamesNoMo,
    grantMiddleNames,
    grantMiddleNamesActive,
    grantNames,
    grantNamesActive,
    grantNamesActiveNoMo,
    grantNamesNoMo,
    tableNames
} from '../../utils/const';
import {
    getGrantsYears,
    getCandidats,
    setGrantsType,
    getCandidatsForFile,
    getCandidatsForExcel,
    getChiefs,
    getCandidatsForFileTrash,
    getCandidatsTrash,
    getInfoForStudent,
    getGrantsOptions,
    getExcelList,
    uploadExcelFile,
    deleteExcelFile, 
    downloadExcelFile
} from '../../actions/grants'
import Loader from 'react-loader';
import Selector from '../shared/Selector';
import Popup from './Popup/index';
import Row from './Row/index';
import PDF from './PDF';
import {createNotification} from '../notifications/notifications';
import moment from 'moment';
import PDF_Candidat from './PDF_Candidat';
import Select from 'react-select';
import PDF_REPORT from './PDF_REPORT';
// import {MdAdd, MdDelete} from 'react-icons/md';
import ReactLoader from 'react-loader';

const mapStateToProps = ({grants, layout}) => {
    const {data: datas} = layout;
    const {
        years,
        candidatslist,
        loading,
        amo,
        government,
        ksmo,
        loading_listFile,
        chief,
        candidatInfo,
        loading_candidatInfo,
        task,
        options,
        excel_list,
        excel_list_loading
    } = grants;
    return {
        years,
        candidatslist,
        loading,
        amo,
        government,
        ksmo,
        loading_listFile,
        chief,
        datas,
        candidatInfo,
        loading_candidatInfo,
        task,
        options,
        excel_list,
        excel_list_loading
    }
}

const Grants = ({
    getGrantsYears,
    getCandidats,
    setGrantsType,
    years,
    candidatslist,
    loading,
    amo,
    government,
    ksmo,
    loading_listFile,
    getCandidatsForFile,
    getCandidatsForExcel,
    getChiefs,
    chief,
    datas,
    getCandidatsForFileTrash,
    getCandidatsTrash,
    getInfoForStudent,
    loading_candidatInfo,
    getGrantsOptions,
    options,
    task,
    excel_list,
    getExcelList,
    uploadExcelFile,
    deleteExcelFile, 
    downloadExcelFile,
    history
}) => {

    const [yearsLocal,
        setYearsLocal] = useState([]) // список годов
    const [year,
        setYear] = useState(null) // выбранный год
    const [isPopup,
        setIsPopup] = useState(false) // отображение попапа
    const [data,
        setData] = useState(null) // отображение попапа
    const [isPdf,
        setIsPdf] = useState(null) // отображение попапа
    const [heads,
        setHeads] = useState([]) // отображение попапа
    const [localLoad,
        setLocalLoad] = useState(false) // отображение попапа

    useEffect(() => {
        getGrantsYears()
        getChiefs()
        return () => {
            getCandidatsTrash();
        }
    }, [])

    const checkMarks = (studentType, tableName, average_grade, list) => {
        // console.log(studentType, tableName, average_grade, list)
        let filteredList = [];  
        if (tableName == 'Слушатели и курсанты ВО') {
            if (studentType == 'Слушатель') {
                if (average_grade >= 4.5) {
                    filteredList = list;
                } else {
                    filteredList = list?.filter(_el => {
                        return _el.label && _el.label !== 'Министерства обороны РФ';
                    })
                }
            } else if (studentType == 'Курсант') {
                if (average_grade == 5) {
                    filteredList = list;
                } else if (average_grade >= 4.5 && average_grade < 4.75) {
                    filteredList = list?.filter(_el => {
                        return _el.label && _el.label !== 'Президента РФ' && _el.label !== 'Министерства обороны РФ';
                    })
                } else if (average_grade >= 4.75 && average_grade < 5) {
                    filteredList = list?.filter(_el => {
                        return _el.label && _el.label !== 'Министерства обороны РФ';
                    })
                }
            }
        } else {
            filteredList = list
        }
        
        return filteredList;
    }

    const check = (data) => {
        return data
            ?.some((element) => element[1]
                ?.length > 0);
    };

    useEffect(() => {
        if (!years) {
            return
        }
        const newYears = years
            ?.map(({name, xp_key}) => ({name, value: xp_key})).reverse()
        setYearsLocal([...newYears])
    }, [years])

    useEffect(() => {
        if (!yearsLocal || yearsLocal
            ?.length === 0) {
            return
        }
        const yearNow = moment()
            .year()
            .toString();
        const yearCurrent = yearsLocal
            ?.find((val) => val.name.includes(yearNow))
            ?.value
            .toString();
        setYear(yearCurrent || '0')
    }, [yearsLocal])

    useEffect(() => {
        getCandidatsTrash()
        if (year == '0' || !year) {
            return
        }
        getGrantsOptions(year);
    }, [year])

    useEffect(() => {
        // if (!candidatslist || candidatslist.length === 0) {
        //     return
        // }

        setData([
            // [
            //     'scholarship_higher_education_listener', candidatslist.scholarship_higher_education_listener
            // ],
            // [
            //     'scholarship_higher_education_cadet', candidatslist.scholarship_higher_education_cadet
            // ],
            [
                'scholarship_higher_education_adjunct', candidatslist?.scholarship_higher_education_adjunct || []
            ],
            [
                'scholarship_higher_education_cadet_listener', candidatslist?.scholarship_higher_education_cadet_listener || []
            ],
            [
                'scholarship_secondary_education', candidatslist?.scholarship_secondary_education || []
            ]
        ])
    }, [candidatslist])

    useEffect(() => {
        if (amo && amo?.scholarship_candidates_higher_adjunct?.length === 0 && 
            amo?.scholarship_candidates_higher_cadet?.length === 0 && 
            amo?.scholarship_candidates_higher_listener?.length === 0 && 
            government && government?.government_scholarship_candidates_higher_cadet_listener?.length === 0 && 
            government?.government_scholarship_candidates_secondary_cadet?.length === 0 && 
            government?.president_scholarship_candidates_higher_cadet_listener?.length === 0 && 
            ksmo && ksmo?.scholarship_candidates_higher_cadet?.length === 0 && 
            ksmo?.scholarship_candidates_higher_listener?.length === 0
        ) {
            createNotification('error', 'Нет данных')
        }
    }, [amo, government, ksmo])

    const getOptions = (count, scholarship_type, name) => {
        if (name === 'scholarship_secondary_education') {
            return scholarship_type == null
                ? grantMiddleNames
                : grantMiddleNamesActive
        } else if (name === 'scholarship_higher_education_adjunct' && count > 0) {
            return scholarship_type == null
                ? grantAdjunctNames
                : grantAdjunctNamesActive
        } else if (name === 'scholarship_higher_education_adjunct' && count == 0) {
            return scholarship_type == null
                ? grantAdjunctNamesNoMo
                : grantAdjunctNamesActiveNoMo
        } else if (name === 'scholarship_higher_education_cadet' && count == 0) {
            return scholarship_type == null
                ? grantNamesNoMo
                : grantNamesActiveNoMo
        } else {
            return scholarship_type == null
                ? grantNames
                : grantNamesActive
        }
    }

    useEffect(() => {
        setLocalLoad(loading_listFile || loading || loading_candidatInfo)          
    }, [loading_listFile, loading, loading_candidatInfo])
    

    const changeGrant = (scholarship_type, el, tableName) => {
        const {mid, gid, education_level} = el;
        const newData = data.map(item => { // изменение типа стипендии локально
            if (item[0] === tableName) {
                return [
                    item[0], item[1].map(_el => {
                        if (_el.mid === mid) {
                            return {
                                ..._el,
                                grants: scholarship_type
                                    ?.[scholarship_type
                                            ?.length - 1]
                                        ?.label == 'Исключить'
                                            ? [
                                                {
                                                    value: 'Исключить',
                                                    label: 'Исключить'
                                                }
                                            ]
                                            : scholarship_type.filter(el => el.label != 'Исключить')
                            };
                        }
                        return _el;
                    })
                ];
            }
            return item;
        });

        setData(newData);

        setGrantsType({
            mid,
            xp_key: Number(year),
            gid,
            education_level,
            scholarship_type: scholarship_type
                ?.[scholarship_type
                        ?.length - 1]
                    ?.label == 'Исключить'
                        ? ['Исключить']
                        : scholarship_type
                            ?.filter(el => el.label != 'Исключить')
                                .map(el => el.label)
        }); // сохранение типа стипендии
    };

    const handleGetFile = async() => {
        if (loading_listFile) 
            return
        await getCandidatsForFile('ksmo', year, task)
        await getCandidatsForFile('amo', year, task)
        await getCandidatsForFile('government', year, task)
        setIsPdf(true)
        // setHeads([])
    }

    const handleDeleteHead = (id) => () => {
        const newHeads = heads.filter(el => el.id !== id)
        setHeads(newHeads)
    }

    const getCandidatInfo = (info) => {
        const {mid, gid, education_level, prep_struc_category_id} = info;
        getInfoForStudent(mid, gid, year, education_level, prep_struc_category_id)
    }

    const handleCandidateInfo = (info) => {
        getExcelList(info.mid);
        setHeads([{
            id: 2,
            title: 'Подписант',
            name: '',
            rank: '',
            post: '',
            date: '',
            data: info,
            type: 'info'
        }])
    }

    const setRowData = (ind) => (data) => {
        const newData = [...heads]
        newData.splice(ind, 1, data)
        setHeads(newData)
    }

    const handleGetFiles = async () => {
        try {
            // Сначала выполняем запрос getCandidats(yearsLocal)
            await getCandidats(year);
    
            // После завершения запроса выполняем остальную логику
            if (heads[0].type === 'info') {
                getCandidatInfo(heads[0].data);
            } else if (heads[0].type === 'files') {
                handleGetFile();
            } else {
                const newHeads = heads.map(el => ({ ...el, done: true }));
                setHeads(newHeads);
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса getCandidats:', error);
        }
    };
    
    const handleGetExcel = async () => {
        if (
            (candidatslist?.scholarship_higher_education_cadet_listener?.length || 0) + 
            (candidatslist?.scholarship_higher_education_adjunct?.length || 0) + 
            (candidatslist?.scholarship_secondary_education?.length || 0) === 0
        ) {
            return createNotification('error', 'Нет данных для экспорта');
        } else {            
            if (candidatslist.scholarship_higher_education_cadet_listener?.length > 0) {
                await getCandidatsForExcel('government', year, task, 'Президента/Правительства РФ - Курсанты и Слушатели');
            }
            if (candidatslist.scholarship_higher_education_adjunct?.length > 0) {
                await getCandidatsForExcel('amo', year, task, 'МО РФ - Адъюнкты');
            }
            if (candidatslist.scholarship_secondary_education?.length > 0) {
                await getCandidatsForExcel('ksmo', year, task, 'МО РФ - Курсанты и Слушатели');
            }
        }
    }
    
    const handleDeleteExcel = (chapter, file_name) => {
        deleteExcelFile(heads[0].data.mid, chapter, file_name)
    }

    const excelHandler = (e, el) => { 
        const file = e.target.files[0]
        uploadExcelFile(file, el, heads[0].data.mid);
    }

    const getExcelObj = (item, chapter) => {
        return item?.find(excel => excel.сhapter == chapter)
    }

    return ( <> <div className={styles.wrapper}>
        <p className={styles.title}>Формирование списка кандидатов на стипендии
            Президента РФ, Правительства РФ, Министерства обороны РФ</p>

        {isPopup && <Popup
            year={year}
            setYear={setYear}
            setIsPopup={setIsPopup}
            yearsLocal={yearsLocal}/>}
        <div className={styles.panel}>
            <div className={styles.selectLeft}>
                <Selector
                    label='Учебный год, на который назначается стипендия'
                    width='300px'
                    options={[...yearsLocal]}
                    onChange={(e) => setYear(e)}
                    value={year}/>
                <div className={styles.button} onClick={() => setIsPopup(true)}>Настройки</div>
                <div className={styles.button} onClick={() => getCandidats(year)}>Сформировать список</div>
                <div className={styles.button} onClick={() => history.push('/grant_types')}>Виды стипендий</div>
            </div>

            <div className={styles.selectRight}>
                {(!loading && check(data)) && <div
                    className={styles.button}
                    onClick={() => setHeads([
                    {
                        id: 1,
                        title: 'Утверждает',
                        name: '',
                        rank: '',
                        post: '',
                        date: '',
                        type: 'files'
                    },
                    {
                        id: 2,
                        title: 'Подписант',
                        name: '',
                        rank: '',
                        post: '',
                        date: '',
                        type: 'files'
                    }
                ])}>
                    Печать списков
                </div>}
                {!loading && options && candidatslist && data && year != '0' &&
                <button
                    className={styles.buttonExcel}
                    type='button'
                    onClick={() => handleGetExcel()}>
                        {loading_listFile && <ReactLoader/>}
                        Excel</button>}
                {!loading && <PDF
                    setHeads={setHeads}
                    heads={heads}
                    handleGetFile={handleGetFile}
                    isPdf={isPdf}
                    setIsPdf={setIsPdf}
                    candidatslist={data}
                    amo={amo}
                    government={government}
                    ksmo={ksmo}
                    loading_listFile={loading_listFile}
                    chief={chief}
                    GOU={datas.GOU_Name}
                    getCandidatsForFileTrash={getCandidatsForFileTrash}
                    yearsLocal={yearsLocal
                    ?.find(el => el.value == year)
                        ?.name}/>}

                {!loading && options && candidatslist && data && year != '0' && <PDF_REPORT
                    checkMarks={checkMarks}
                    setHeads={setHeads}
                    heads={heads}
                    chief={chief}
                    GOU={datas.GOU_Name}
                    candidatslist={candidatslist}
                    data={data}
                    year={year}
                    yearsLocal={yearsLocal
                    ?.find(el => el.value == year)
                        ?.name}
                    tableNames={tableNames}
                    options={options}/>
}
                <PDF_Candidat
                    GOU={datas.GOU_Name}
                    setHeads={setHeads}
                    heads={heads}
                    year={yearsLocal
                    ?.find(el => el.value == year)
                        ?.name}/>
            </div>
        </div>

        {heads && heads.length > 0
            ? <div className={styles.headPopup}>
                    <div className={styles.headPopupContent}>
                        <div className={styles.headsTitle}>{
                            heads?.[1] ? 'Укажите лиц, утверждающих и подписывающих документ' : 'Укажите лицо подписывающее документ'
                            }
                        </div>
                        <div className={styles.headsWrapper}>
                            <div className={styles.heads}>
                                {heads?.map((el, i) =>
                                    <Row
                                        
                                        key={`head-${el.id}`}
                                        row={el}
                                        setRow={setRowData(i)}
                                        lastRow={heads.length - 1 === i}
                                        addRow={() => setHeads([...heads, {
                                            id: el.id + 1,
                                            name: '',
                                            rank: '',
                                            post: ''
                                        }])}
                                        deleteRow={handleDeleteHead(el.id)}
                                    />
                                )
                                }
                            </div>
                        </div>

                        {heads?.[0]?.id == 2 && <div className={styles.excelWrapper}>
                                <div className={styles.excelTitle}>ФАЙЛЫ</div>
                                {chapterList.map(el => 
                                        getExcelObj(excel_list, el.id) ? 
                                        <div key={el.id} className={styles.excelItem}>
                                            <div className={styles.excelNum}>{el.name}</div>
                                                <div 
                                                    onClick={() => downloadExcelFile(heads[0].data.mid, el.id, getExcelObj(excel_list, el.id)?.file_name)}
                                                    className={styles.excelName}>
                                                    {getExcelObj(excel_list, el.id)?.file_name}
                                                </div>
                                            <div className={styles.excelDelete} onClick={() => handleDeleteExcel(el.id, getExcelObj(excel_list, el.id)?.file_name)}>Удалить</div>
                                        </div> : 
                                        <div key={el.id} className={styles.excelItem}>
                                            <div className={styles.excelNum}>{el.name}</div>
                                            <div className={styles.excelAdd}>
                                                <label 
                                                    htmlFor={`fileExcel-${el.id}`} 
                                                    className={styles.excelAddBtn}>Загрузить</label>
                                                <input 
                                                    id={`fileExcel-${el.id}`}
                                                    hidden 
                                                    type="file" 
                                                    onChange={(e) => excelHandler(e, el.id)}/>
                                            </div>
                                            <div></div>
                                        </div>
                                    )
                                }
                        </div>}
                        
                            <div className={styles.buttons}>
                                <button
                                    className={styles.buttonHeadClose}
                                    type='button'
                                    onClick={() => setHeads([])}>Закрыть</button>
                                <button
                                    className={styles.buttonHeadOk}
                                    type='button'
                                    onClick={() => handleGetFiles()}>
                                        {/* {loading_listFile && <ReactLoader/>} */}
                                        Печать</button>
                            </div>
                    </div>
                </div>
            : <></>}

        <Loader loaded={!localLoad} color='grey'>
            <div className={styles.loader_candidat}>
                <table className={styles.table}>
                    <thead>
                        {
                            candidatslist && data &&
                            <tr>
                                <th colSpan={
                                    8 
                                    + candidatslist?.columns_honours
                                    ?.filter((el_) => el_?.parent_id == 150)?.length
                                    }></th>
                                <th colSpan={candidatslist?.columns_honours
                                    ?.filter((el_) => el_?.parent_id == 150)?.length || 1}>
                                    {
                                        candidatslist?.columns_honours
                                            ?.find((el_) => el_?.previous_level_id == 150)
                                            .previous_level_title || 'Достижения в учебе и науке, всего'
                                    }
                                </th>
                                <th colSpan={5}></th>
                            </tr>
                        }
                        <tr>
                            <th
                                className={styles.table__title}
                                style={{
                                width: '75px'
                            }}>№
                                <br/>п/п</th>
                            <th className={styles.table__title}>В/зв</th>
                            <th className={styles.table__title}>ФИО</th>
                            <th className={styles.table__title}>Должность</th>
                            <th className={styles.table__title}>Номер группы</th>
                            <th className={styles.table__title}>Курс обучения</th>
                            <th className={styles.table__title}>Средний балл</th>
                            <th className={styles.table__title}>Кол-во и процент "отлично"</th>
                            <th className={styles.table__title}>Кол-во и процент "хорошо"</th>
                            {candidatslist
                                ?.columns_honours
                                ?.filter((el_) => el_.previous_level_id != 150)
                                    ?.map((el) => (
                                        <th className={styles.table__title} key={el.id}>{el.previous_level_title
                                                ? el.previous_level_title
                                                : 'Пусто'}</th>
                                    ))}
                            <th className={styles.table__title}>Суммарный коэффициент достижений</th>
                            <th className={styles.table__title}>Текущая успеваемость</th>
                            <th
                                className={styles.table__title}
                                style={{
                                width: '200px'
                            }}>Претендует на назначение следующего вида стипендии или Исключению из списка</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data && year != '0' && data
                            ?.map((arr, i) => ( <> <tr className={styles.tableTitle}>
                                    <td colSpan={100}>{tableNames
                                            ?.[arr[0]]}</td>
                                </tr>

                                {
                                arr[1]
                                    ?.length > 0
                                        ? arr[1].sort((a, b) => b.average_grade - a.average_grade)
                                        .map((el, i) => (
                                            <tr
                                                key={el.mid}
                                                className={styles.tableRow}
                                                title='*для формирования документа Общие сведения о кандидате необходимо кликнуть два раза левой клавишей мыши по ФИО кандидата'
                                                onDoubleClick={() => handleCandidateInfo(el)}>
                                                <td>{i + 1}</td>
                                                <td>{el.militaryrank}</td>
                                                <td>{el.student_name}</td>
                                                <td>{el.prep_struc_category}</td>
                                                <td>{el.group_name}</td>
                                                <td>{el.yeducationyear}</td>
                                                <td>{el.average_grade}</td>
                                                <td>{el.five_count}
                                                    / {el
                                                        .five_percentage
                                                        .toFixed(0)}%</td>
                                                <td>{el.four_count}
                                                    / {el
                                                        .four_percentage
                                                        .toFixed(0)}%</td>
                                                {candidatslist
                                                ?.columns_honours
                                                ?.filter(el_ => el_?.parent_id != 150)
                                                .map((_el, _i) => {
                                                    if (_el.previous_level_id == 150) {
                                                        let dd = el?.third_level_data?.find(__el => __el.previous_level_id === 150) || {
                                                            data: [
                                                                { last_level_count: 0, last_level_points: 0 },
                                                                { last_level_count: 0, last_level_points: 0 },
                                                                { last_level_count: 0, last_level_points: 0 }
                                                            ]
                                                        }; ;
                                                        let item = {data: [
                                                            dd?.data?.find(__el => __el.previous_level_id === 151) || {last_level_count: 0, last_level_points: 0}, 
                                                            dd?.data?.find(__el => __el.previous_level_id === 152) || {last_level_count: 0, last_level_points: 0}, 
                                                            dd?.data?.find(__el => __el.previous_level_id === 153) || {last_level_count: 0, last_level_points: 0}, 
                                                        ] }
                                                        
                                                        
                                                        return item?.data?.map((elem, i_elem) => {
                                                            const count = elem?.last_level_count || 0;
                                                            const coeff = elem?.last_level_points || 0;
                                                            const value = `${count} / ${coeff}`;
                                                            return <td key={i_elem}>{value}</td>;
                                                        });
                                                    } else {
                                                        const item = el?.third_level_data?.find(__el => __el.previous_level_id === _el.previous_level_id);
                                                        const count = item?.last_level_count || 0;
                                                        const coeff = item?.last_level_points || 0;
                                                        const value = `${count} / ${coeff}`;
                                                        return <td key={_i}>{value}</td>;
                                                    }
                                                })
                                                }
                                                <td>{el.record_points || 0}</td>
                                                <td>{el.current_avg_grade || 0}</td>
                                                <td onDoubleClick={(e) => e.stopPropagation()}>
                                                    <div className={styles.select}>
                                                        <Select
                                                            className={styles.select__input}
                                                            placeholder='Вид стипендии'
                                                            isClearable={false}
                                                            isMulti
                                                            options={
                                                                checkMarks(
                                                                    el.prep_struc_category, 
                                                                    tableNames?.[arr[0]],
                                                                    el.average_grade,
                                                                    getOptions(el.record_count_year, el.scholarship_type, arr[0]))
                                                                }
                                                            onChange={(e) => changeGrant(e, el, arr[0])}
                                                            isSelected={getOptions(el, el.scholarship_type, arr[0])}
                                                            value={el
                                                            ?.grants
                                                                ?.map(el => ({
                                                                    label: el.scholarship_type || el.label,
                                                                    value: el.scholarship_type || el.value
                                                                }))}/>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                        : <tr>
                                                <td colSpan={100}>Нет данных</td>
                                            </tr>
                            } </>
                            ))}
                    </tbody>
                </table>

                <div>*для формирования документа Общие сведения о кандидате необходимо кликнуть два раза левой клавишей мыши по ФИО кандидата</div>
            </div>
        </Loader>
    </div> </>
  )
}

export default connect(mapStateToProps, {getGrantsYears, getCandidats, setGrantsType, getCandidatsForFile, getCandidatsForExcel, getChiefs, getCandidatsForFileTrash, getCandidatsTrash, getInfoForStudent, getGrantsOptions, getExcelList, uploadExcelFile, deleteExcelFile, downloadExcelFile})(Grants)